import { Card, CardBody, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"
import { ACCESS } from "constants/accessPermissions"
import { CanView } from "components/Common/CanView"

const AdminTab = () => (
  <Card className="border-0 shadow-sm">
    <CardBody>
      <div className="mb-4">
        <h5 className="mb-1">Admin Tools</h5>
        <p className="text-muted mb-0 small">Audit and system health stay accessible from the same finance entry point.</p>
      </div>
      <Row className="g-3">
        <CanView access={[ACCESS.ACCOUNT_AUDIT_LOG.VIEW_LIST]}>
          <Col md={6}>
            <Link to="/audit-log-list" className="text-decoration-none">
              <div className="border rounded-3 p-3 h-100">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <i className="mdi mdi-text-box-search-outline text-primary" style={{ fontSize: 24 }} />
                  <i className="mdi mdi-chevron-right text-muted" />
                </div>
                <div className="fw-semibold text-dark">Audit Log</div>
                <div className="text-muted small mt-1">Review who changed what in finance records.</div>
              </div>
            </Link>
          </Col>
        </CanView>
        <CanView access={[ACCESS.ACCOUNT_API_STATUS.VIEW]}>
          <Col md={6}>
            <Link to="/api-status" className="text-decoration-none">
              <div className="border rounded-3 p-3 h-100">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <i className="mdi mdi-lan-check text-success" style={{ fontSize: 24 }} />
                  <i className="mdi mdi-chevron-right text-muted" />
                </div>
                <div className="fw-semibold text-dark">API Status & Features</div>
                <div className="text-muted small mt-1">Open the operational health and feature support screen.</div>
              </div>
            </Link>
          </Col>
        </CanView>
      </Row>
    </CardBody>
  </Card>
)

export default AdminTab
